export const FILTERS = [
	'dance',
	'jazz',
	'pop music',
	'rock',
	'rap',
	'eclectic',
	'atmospheric',
	'alternative',
	'folk',
	'music',
];
